<template>
  <el-dialog :title="$t('1366')" append-to-body :visible.sync="visible" :close-on-click-modal="false" width="648px">
    <div>
      <div class="search">
        <div>
          <el-input
            type="text"
            v-model="form.name"
            :placeholder="$t('da8c681e')"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
          <!-- 查询 -->
          <el-button type="primary" size="small" class="query" @click="handlerQuery" v-if="$p(p)">{{
            $t('80')
          }}</el-button>
          <el-checkbox class="query" v-model="is_all" v-if="$p(p)" @change="handlerQuery">{{
            $t('b876c049')
          }}</el-checkbox>
        </div>
        <el-button size="small" @click="handlerCreateSch" v-if="$p(p + '.edit')">{{ $t('1729') }}</el-button>
      </div>
      <!-- 表格数据 -->
      <div class="table-wrap">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-load="loading"
          @selection-change="handlerSelection"
          ref="table"
        >
          <el-table-column type="selection" width="65" v-if="isMultiple" :selectable="checkSelectable">
          </el-table-column>
          <el-table-column width="36px" v-else>
            <template slot-scope="scope">
              <el-radio v-model="form.shift" :label="scope.row" :disabled="scope.row.id === '1'">{{ '' }}</el-radio>
            </template>
          </el-table-column>
          <!-- 班次名称 -->
          <el-table-column prop="name" :label="$t('1362')"></el-table-column>
          <!-- 考勤时间 -->
          <el-table-column :label="$t('1363')">
            <template slot-scope="scope">
              <span>
                {{ scope.row.start }} ~ <label v-if="scope.row.end_mark">{{ scope.row.end_mark }}</label>
                {{ scope.row.end }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div class="page-wrap">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-size="page.size"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div> -->
      </div>
    </div>
    <!-- 确认取消 -->
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('131') }}</el-button>
    </span>
    <!-- 编辑新建 -->
    <Edit ref="edit" @updateList="getShiftList" />
  </el-dialog>
</template>

<script>
import { shiftList } from 'api/frequency'
import Edit from '@/views/Attendance/frequency/modal'

export default {
  components: {
    Edit
  },
  props: {
    p: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    visible: false,
    is_all: true,
    form: {
      is_all: 0,
      name: '',
      shift: {} // 所选班次
    },
    page: {
      page: 1,
      size: 1000000000,
      total: 0
    },
    loading: false,
    tableData: [],
    index: null,
    isMultiple: false,
    selected: [],
    currentShiftId: undefined
  }),
  watch: {
    visible(v) {
      if (!v) {
        this.form.name = ''
        this.form.shift = {}
      }
    }
  },
  methods: {
    handlerCreateSch() {
      const msg = {
        title: this.$t('1729'),
        type: 1
      }
      this.$refs.edit.init(msg)
    },
    updateCurrentShiftId(shiftId) {
      this.currentShiftId = shiftId
    },
    updateFormShiftById(currentShiftId, tableData) {
      if (!currentShiftId) return
      const item = tableData.find(item => item.id === currentShiftId)
      if (!item) return
      this.form.shift = item
    },
    // index要修改的数据 isMultiple是否多选 data 默认选中项
    init(index, isMultiple, data) {
      // 修改单条数据索引
      if (!index && index !== 0) {
        this.index = null
      } else {
        this.index = index
      }
      this.isMultiple = isMultiple || false
      this.visible = true
      // 已选
      this.selected = data
      if (this.$p(this.p + '.edit')) this.getShiftList(data)
    },
    // 默认选中
    defaultSelect(arr) {
      this.tableData.forEach(item => {
        arr.forEach(params => {
          if (params.shift_id === item.id) {
            this.$refs.table.toggleRowSelection(item, true)
          }
        })
      })
    },
    // 查询
    handlerQuery() {
      this.page.page = 1
      this.getShiftList()
    },
    handleCurrentChange(currentPage) {
      this.page.page = currentPage
      this.getShiftList()
    },
    // 表格禁选
    checkSelectable(row) {
      // console.log(row)
      return row.id !== '1'
    },
    // 获取数据
    async getShiftList() {
      this.loading = true
      this.form.is_all = this.is_all ? 0 : 1
      const res = await shiftList({
        ...this.form,
        ...this.page
      })
      this.loading = false
      this.tableData = res.data.result
      this.page.total = res.data.count
      // 表格回显
      this.selected && this.$nextTick(() => this.defaultSelect(this.selected))
      this.updateFormShiftById(this.currentShiftId || this.form.shift.id, this.tableData)
    },
    confirm() {
      this.visible = false
      this.$emit('change', this.isMultiple ? this.form.shift : { ...this.form.shift, index: this.index })
    },
    handlerSelection(params) {
      this.form.shift = params
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .query {
    margin-left: 15px;
  }
}
.table-wrap {
  margin-top: 10px;
}
</style>
